

// // frontend/src/pages/GradeSubmissions.js
// import React, { useState, useEffect, useContext } from 'react';
// import {
//   Container,
//   Typography,
//   Box,
//   Card,
//   CardContent,
//   TextField,
//   MenuItem,
//   Button,
//   CircularProgress,
//   Snackbar,
//   Alert,
//   Table,
//   TableHead,
//   TableRow,
//   TableCell,
//   TableBody,
// } from '@mui/material';
// import axios from 'axios';
// import { AuthContext } from '../contexts/AuthContext';

// const allowedGrades = ["A", "A+", "B", "B+", "C", "D"];

// const GradeSubmissions = () => {
//   const { token } = useContext(AuthContext);

//   const [assignments, setAssignments] = useState([]);
//   const [selectedAssignment, setSelectedAssignment] = useState('');
//   const [submissions, setSubmissions] = useState([]);
//   const [loading, setLoading] = useState(false);
//   const [grading, setGrading] = useState({});
//   const [snackbar, setSnackbar] = useState({ open: false, message: '', severity: 'info' });

//   // Fetch assignments posted by the teacher
//   useEffect(() => {
//     const fetchAssignments = async () => {
//       try {
//         const res = await axios.get(`${process.env.REACT_APP_API_URL}/api/assignments`, {
//           headers: { Authorization: `Bearer ${token}` }
//         });
//         setAssignments(res.data || []);
//       } catch (error) {
//         console.error('Error fetching assignments:', error);
//         setSnackbar({ open: true, message: 'Failed to load assignments.', severity: 'error' });
//       }
//     };
//     if (token) fetchAssignments();
//   }, [token]);

//   // Fetch submissions when an assignment is selected
//   useEffect(() => {
//     if (!selectedAssignment) return;

//     const fetchSubmissions = async () => {
//       setLoading(true);
//       try {
//         const res = await axios.get(
//           `${process.env.REACT_APP_API_URL}/api/assignments/${selectedAssignment}/submissions`,
//           { headers: { Authorization: `Bearer ${token}` } }
//         );
//         setSubmissions(res.data || []);
//       } catch (error) {
//         console.error('Error fetching submissions:', error);
//         setSnackbar({ open: true, message: 'Failed to load submissions.', severity: 'error' });
//       } finally {
//         setLoading(false);
//       }
//     };

//     fetchSubmissions();
//   }, [selectedAssignment, token]);

//   const handleGradeChange = (submissionId, field, value) => {
//     setGrading(prev => ({ ...prev, [submissionId]: { ...prev[submissionId], [field]: value } }));
//   };

//   const handleSubmitGrade = async (submissionId) => {
//     const { letterGrade, feedback } = grading[submissionId] || {};
//     if (!letterGrade) {
//       setSnackbar({ open: true, message: 'Please select a letter grade.', severity: 'warning' });
//       return;
//     }

//     try {
//       await axios.put(`${process.env.REACT_APP_API_URL}/api/assignments/grade`, 
//         { submissionId, letterGrade, feedback },
//         { headers: { Authorization: `Bearer ${token}` } }
//       );
//       setSnackbar({ open: true, message: 'Graded successfully!', severity: 'success' });

//       // Update local state
//       setSubmissions(prev => prev.map(s => s._id === submissionId ? { ...s, letterGrade, feedback } : s));
//     } catch (error) {
//       console.error('Error grading submission:', error);
//       setSnackbar({ open: true, message: 'Failed to grade submission.', severity: 'error' });
//     }
//   };

//   return (
//     <Box sx={{ minHeight: '100vh', py: 4, background: 'linear-gradient(135deg,#f5f7fa,#c3cfe2)' }}>
//       <Container maxWidth="md">
//         <Card sx={{ p: 3, borderRadius: 2, boxShadow: 3, background: 'linear-gradient(145deg,#fff,#f0f0f0)' }}>
//           <CardContent>
//             <Typography variant="h4" sx={{ fontWeight: 'bold', color: 'primary.main', mb: 3 }}>
//               Grade Submissions
//             </Typography>

//             {/* Assignment Dropdown */}
//             <TextField
//               select
//               label="Select Assignment"
//               fullWidth
//               value={selectedAssignment}
//               onChange={(e) => setSelectedAssignment(e.target.value)}
//               margin="normal"
//             >
//               <MenuItem value="">-- Select Assignment --</MenuItem>
//               {assignments.map(a => (
//                 <MenuItem key={a._id} value={a._id}>
//                   {a.title}
//                 </MenuItem>
//               ))}
//             </TextField>

//             {loading ? (
//               <Box sx={{ display: 'flex', justifyContent: 'center', mt: 4 }}><CircularProgress /></Box>
//             ) : submissions.length === 0 ? (
//               selectedAssignment && <Typography sx={{ mt: 2 }}>No submissions for this assignment yet.</Typography>
//             ) : (
//               <Table sx={{ mt: 3 }}>
//                 <TableHead>
//                   <TableRow>
//                     <TableCell>Student</TableCell>
//                     <TableCell>File</TableCell>
//                     <TableCell>Letter Grade</TableCell>
//                     <TableCell>Feedback</TableCell>
//                     <TableCell>Action</TableCell>
//                   </TableRow>
//                 </TableHead>
//                 <TableBody>
//                   {submissions.map(sub => (
//                     <TableRow key={sub._id}>
//                       <TableCell>{sub.studentId.username}</TableCell>
//                       <TableCell>
//                         <Button onClick={() => window.open(sub.fileUrl, '_blank')} variant="outlined" size="small">
//                           View File
//                         </Button>
//                       </TableCell>
//                       <TableCell>
//                         <TextField
//                           select
//                           value={grading[sub._id]?.letterGrade || sub.letterGrade || ''}
//                           onChange={(e) => handleGradeChange(sub._id, 'letterGrade', e.target.value)}
//                           size="small"
//                         >
//                           <MenuItem value="">--Select--</MenuItem>
//                           {allowedGrades.map(g => <MenuItem key={g} value={g}>{g}</MenuItem>)}
//                         </TextField>
//                       </TableCell>
//                       <TableCell>
//                         <TextField
//                           value={grading[sub._id]?.feedback || sub.feedback || ''}
//                           onChange={(e) => handleGradeChange(sub._id, 'feedback', e.target.value)}
//                           size="small"
//                         />
//                       </TableCell>
//                       <TableCell>
//                         <Button variant="contained" size="small" onClick={() => handleSubmitGrade(sub._id)}>
//                           Save
//                         </Button>
//                       </TableCell>
//                     </TableRow>
//                   ))}
//                 </TableBody>
//               </Table>
//             )}
//           </CardContent>
//         </Card>
//       </Container>

//       {/* Snackbar */}
//       <Snackbar
//         open={snackbar.open}
//         autoHideDuration={3000}
//         onClose={() => setSnackbar({ ...snackbar, open: false })}
//         anchorOrigin={{ vertical: 'bottom', horizontal: 'center' }}
//       >
//         <Alert severity={snackbar.severity}>{snackbar.message}</Alert>
//       </Snackbar>
//     </Box>
//   );
// };

// export default GradeSubmissions;

import React, { useState, useEffect, useContext } from 'react';
import axios from 'axios';
import { AuthContext } from '../contexts/AuthContext';

const allowedGrades = ["A", "A+", "B", "B+", "C", "D"];

const GradeSubmissions = () => {
  const { token } = useContext(AuthContext);

  const [assignments, setAssignments] = useState([]);
  const [selectedAssignment, setSelectedAssignment] = useState('');
  const [submissions, setSubmissions] = useState([]);
  const [loading, setLoading] = useState(false);
  const [grading, setGrading] = useState({});
  const [snackbar, setSnackbar] = useState({ open: false, message: '', severity: 'info' });

  // Fetch assignments posted by the teacher
  useEffect(() => {
    const fetchAssignments = async () => {
      try {
        const apiUrl = process.env.REACT_APP_API_URL || 'http://localhost:5000';
        const res = await axios.get(`${apiUrl}/api/assignments`, {
          headers: { Authorization: `Bearer ${token}` }
        });
        setAssignments(res.data || []);
      } catch (error) {
        console.error('Error fetching assignments:', error);
        setSnackbar({ open: true, message: 'Failed to load assignments.', severity: 'error' });
      }
    };
    if (token) fetchAssignments();
  }, [token]);

  // Fetch submissions when an assignment is selected
  useEffect(() => {
    if (!selectedAssignment) return;

    const fetchSubmissions = async () => {
      setLoading(true);
      try {
        const apiUrl = process.env.REACT_APP_API_URL || 'http://localhost:5000';
        const res = await axios.get(
          `${apiUrl}/api/assignments/${selectedAssignment}/submissions`,
          { headers: { Authorization: `Bearer ${token}` } }
        );
        setSubmissions(res.data || []);
      } catch (error) {
        console.error('Error fetching submissions:', error);
        setSnackbar({ open: true, message: 'Failed to load submissions.', severity: 'error' });
      } finally {
        setLoading(false);
      }
    };

    fetchSubmissions();
  }, [selectedAssignment, token]);

  const handleGradeChange = (submissionId, field, value) => {
    setGrading(prev => ({ ...prev, [submissionId]: { ...prev[submissionId], [field]: value } }));
  };

  const handleSubmitGrade = async (submissionId) => {
    const { letterGrade, feedback } = grading[submissionId] || {};
    if (!letterGrade) {
      setSnackbar({ open: true, message: 'Please select a letter grade.', severity: 'warning' });
      return;
    }

    try {
      const apiUrl = process.env.REACT_APP_API_URL || 'http://localhost:5000';
      await axios.put(`${apiUrl}/api/assignments/grade`, 
        { submissionId, letterGrade, feedback },
        { headers: { Authorization: `Bearer ${token}` } }
      );
      setSnackbar({ open: true, message: 'Graded successfully!', severity: 'success' });

      // Update local state
      setSubmissions(prev => prev.map(s => s._id === submissionId ? { ...s, letterGrade, feedback } : s));
    } catch (error) {
      console.error('Error grading submission:', error);
      setSnackbar({ open: true, message: 'Failed to grade submission.', severity: 'error' });
    }
  };

  const closeSnackbar = () => {
    setSnackbar({ ...snackbar, open: false });
  };

  const getGradeColor = (grade) => {
    switch (grade) {
      case 'A':
      case 'A+':
        return { bg: 'rgba(16, 185, 129, 0.1)', color: '#059669', border: 'rgba(16, 185, 129, 0.3)' };
      case 'B':
      case 'B+':
        return { bg: 'rgba(59, 130, 246, 0.1)', color: '#2563eb', border: 'rgba(59, 130, 246, 0.3)' };
      case 'C':
        return { bg: 'rgba(245, 158, 11, 0.1)', color: '#d97706', border: 'rgba(245, 158, 11, 0.3)' };
      case 'D':
        return { bg: 'rgba(239, 68, 68, 0.1)', color: '#dc2626', border: 'rgba(239, 68, 68, 0.3)' };
      default:
        return { bg: 'rgba(156, 163, 175, 0.1)', color: '#6b7280', border: 'rgba(156, 163, 175, 0.3)' };
    }
  };

  return (
    <div className="grade-submissions-container">
      <style>{`
        @import url('https://fonts.googleapis.com/css2?family=Inter:wght@300;400;500;600;700;800;900&display=swap');
        
        .grade-submissions-container {
          min-height: 100vh;
          background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
          position: relative;
          overflow: hidden;
          padding: 2rem 1rem;
          font-family: 'Inter', -apple-system, BlinkMacSystemFont, sans-serif;
        }

        .grade-submissions-container::before {
          content: '';
          position: absolute;
          top: 15%;
          right: 10%;
          width: 120px;
          height: 120px;
          border-radius: 50%;
          background: rgba(255, 255, 255, 0.08);
          animation: float 4s ease-in-out infinite;
        }

        .grade-submissions-container::after {
          content: '';
          position: absolute;
          bottom: 20%;
          left: 12%;
          width: 90px;
          height: 90px;
          border-radius: 50%;
          background: rgba(255, 255, 255, 0.05);
          animation: float 3.5s ease-in-out infinite;
          animation-delay: 1.8s;
        }

        @keyframes float {
          0%, 100% { transform: translateY(0px) rotate(0deg); }
          50% { transform: translateY(-15px) rotate(8deg); }
        }

        @keyframes slideIn {
          from { opacity: 0; transform: translateY(30px); }
          to { opacity: 1; transform: translateY(0); }
        }

        @keyframes spin {
          0% { transform: rotate(0deg); }
          100% { transform: rotate(360deg); }
        }

        @keyframes slideInFromBottom {
          from { 
            opacity: 0; 
            transform: translateY(100px); 
          }
          to { 
            opacity: 1; 
            transform: translateY(0); 
          }
        }

        .pulse-element {
          position: absolute;
          top: 35%;
          right: 30%;
          width: 60px;
          height: 60px;
          border-radius: 50%;
          background: rgba(255, 255, 255, 0.06);
          animation: pulse 3s ease-in-out infinite;
        }

        @keyframes pulse {
          0%, 100% { opacity: 0.3; }
          50% { opacity: 0.7; }
        }

        .grading-wrapper {
          max-width: 1200px;
          margin: 0 auto;
          position: relative;
          z-index: 1;
        }

        .header-section {
          text-align: center;
          margin-bottom: 3rem;
        }

        .header-chip {
          display: inline-flex;
          align-items: center;
          gap: 0.5rem;
          background: rgba(255, 255, 255, 0.15);
          color: white;
          padding: 0.5rem 1rem;
          border-radius: 50px;
          font-size: 0.9rem;
          font-weight: 500;
          margin-bottom: 1.5rem;
          backdrop-filter: blur(10px);
        }

        .main-title {
          font-size: clamp(2.2rem, 4vw, 3rem);
          font-weight: 900;
          color: white;
          margin-bottom: 0.5rem;
          text-shadow: 0 4px 20px rgba(0,0,0,0.3);
          animation: slideIn 0.8s ease-out;
        }

        .gradient-text {
          background: linear-gradient(45deg, #FFD700, #FF6B6B, #4ECDC4);
          -webkit-background-clip: text;
          -webkit-text-fill-color: transparent;
          background-clip: text;
        }

        .subtitle {
          color: rgba(255, 255, 255, 0.9);
          font-weight: 300;
          font-size: 1rem;
          animation: slideIn 0.8s ease-out 0.2s both;
        }

        .form-container {
          background: rgba(255, 255, 255, 0.95);
          backdrop-filter: blur(20px);
          border-radius: 24px;
          padding: 3rem;
          border: 1px solid rgba(255, 255, 255, 0.2);
          box-shadow: 0 20px 40px rgba(0,0,0,0.1);
          animation: slideIn 0.6s ease-out 0.4s both;
          position: relative;
          overflow: hidden;
        }

        .form-container::before {
          content: '';
          position: absolute;
          top: 0;
          left: 0;
          right: 0;
          height: 4px;
          background: linear-gradient(90deg, #667eea, #764ba2, #f093fb, #f5576c);
          border-radius: 24px 24px 0 0;
        }

        .form-title {
          display: flex;
          align-items: center;
          gap: 1rem;
          margin-bottom: 2rem;
        }

        .form-icon {
          width: 48px;
          height: 48px;
          background: linear-gradient(45deg, #667eea 30%, #764ba2 90%);
          border-radius: 12px;
          display: flex;
          align-items: center;
          justify-content: center;
          color: white;
          box-shadow: 0 4px 16px rgba(102, 126, 234, 0.3);
        }

        .form-title-text {
          font-size: 1.5rem;
          font-weight: 700;
          color: #1f2937;
        }

        .form-group {
          margin-bottom: 2rem;
        }

        .form-label {
          display: block;
          margin-bottom: 0.5rem;
          font-weight: 600;
          color: #374151;
          font-size: 0.95rem;
        }

        .form-select {
          width: 100%;
          padding: 1.25rem;
          border: 2px solid rgba(209, 213, 219, 0.3);
          border-radius: 12px;
          background: rgba(255, 255, 255, 0.9);
          backdrop-filter: blur(10px);
          font-family: inherit;
          font-size: 1rem;
          transition: all 0.3s ease;
          outline: none;
          cursor: pointer;
        }

        .form-select:focus {
          border-color: #667eea;
          box-shadow: 0 0 0 3px rgba(102, 126, 234, 0.1);
          background: white;
        }

        .loading-container {
          display: flex;
          flex-direction: column;
          align-items: center;
          justify-content: center;
          padding: 4rem 2rem;
          color: #6b7280;
        }

        .loading-spinner {
          width: 48px;
          height: 48px;
          border: 4px solid rgba(102, 126, 234, 0.2);
          border-top: 4px solid #667eea;
          border-radius: 50%;
          animation: spin 1s linear infinite;
          margin-bottom: 1.5rem;
        }

        .loading-text {
          font-size: 1.1rem;
          font-weight: 500;
        }

        .empty-state {
          text-align: center;
          padding: 4rem 2rem;
          color: #6b7280;
        }

        .empty-icon {
          width: 100px;
          height: 100px;
          background: rgba(156, 163, 175, 0.1);
          border-radius: 50%;
          display: flex;
          align-items: center;
          justify-content: center;
          margin: 0 auto 2rem;
          color: #9ca3af;
        }

        .empty-title {
          font-size: 1.5rem;
          font-weight: 700;
          color: #1f2937;
          margin-bottom: 1rem;
        }

        .empty-message {
          font-size: 1rem;
          line-height: 1.6;
        }

        .submissions-table {
          margin-top: 2rem;
        }

        .submissions-header {
          font-size: 1.25rem;
          font-weight: 700;
          color: #1f2937;
          margin-bottom: 1.5rem;
          display: flex;
          align-items: center;
          gap: 0.75rem;
        }

        .table-icon {
          width: 32px;
          height: 32px;
          background: linear-gradient(45deg, #10b981 30%, #059669 90%);
          border-radius: 8px;
          display: flex;
          align-items: center;
          justify-content: center;
          color: white;
        }

        .submission-card {
          background: rgba(255, 255, 255, 0.8);
          border: 2px solid rgba(209, 213, 219, 0.2);
          border-radius: 16px;
          padding: 2rem;
          margin-bottom: 1.5rem;
          transition: all 0.3s ease;
          backdrop-filter: blur(10px);
          animation: slideIn 0.5s ease-out;
        }

        .submission-card:hover {
          border-color: rgba(102, 126, 234, 0.3);
          box-shadow: 0 8px 30px rgba(0,0,0,0.08);
          transform: translateY(-2px);
        }

        .submission-header {
          display: flex;
          align-items: center;
          justify-content: between;
          margin-bottom: 1.5rem;
          flex-wrap: wrap;
          gap: 1rem;
        }

        .student-info {
          display: flex;
          align-items: center;
          gap: 1rem;
          flex: 1;
        }

        .student-avatar {
          width: 48px;
          height: 48px;
          border-radius: 50%;
          background: linear-gradient(45deg, #667eea 30%, #764ba2 90%);
          color: white;
          display: flex;
          align-items: center;
          justify-content: center;
          font-weight: 700;
          font-size: 1.2rem;
        }

        .student-name {
          font-weight: 700;
          color: #1f2937;
          font-size: 1.1rem;
        }

        .view-file-btn {
          background: linear-gradient(45deg, #3b82f6 30%, #1d4ed8 90%);
          color: white;
          border: none;
          padding: 0.75rem 1.5rem;
          border-radius: 12px;
          font-weight: 600;
          cursor: pointer;
          transition: all 0.3s ease;
          display: flex;
          align-items: center;
          gap: 0.5rem;
          box-shadow: 0 4px 16px rgba(59, 130, 246, 0.3);
          text-decoration: none;
        }

        .view-file-btn:hover {
          transform: translateY(-2px);
          box-shadow: 0 8px 25px rgba(59, 130, 246, 0.4);
        }

        .grading-section {
          display: grid;
          grid-template-columns: 200px 1fr 150px;
          gap: 1.5rem;
          align-items: start;
          margin-top: 1.5rem;
          padding-top: 1.5rem;
          border-top: 1px solid rgba(209, 213, 219, 0.3);
        }

        .grade-field {
          display: flex;
          flex-direction: column;
        }

        .field-label {
          font-weight: 600;
          color: #374151;
          font-size: 0.9rem;
          margin-bottom: 0.5rem;
        }

        .grade-select {
          width: 100%;
          padding: 1rem;
          border: 2px solid rgba(209, 213, 219, 0.3);
          border-radius: 8px;
          background: white;
          font-family: inherit;
          font-size: 0.95rem;
          transition: all 0.3s ease;
          outline: none;
        }

        .grade-select:focus {
          border-color: #667eea;
          box-shadow: 0 0 0 3px rgba(102, 126, 234, 0.1);
        }

        .feedback-input {
          width: 100%;
          padding: 1rem;
          border: 2px solid rgba(209, 213, 219, 0.3);
          border-radius: 8px;
          background: white;
          font-family: inherit;
          font-size: 0.95rem;
          transition: all 0.3s ease;
          outline: none;
          resize: vertical;
          min-height: 80px;
        }

        .feedback-input:focus {
          border-color: #667eea;
          box-shadow: 0 0 0 3px rgba(102, 126, 234, 0.1);
        }

        .save-grade-btn {
          background: linear-gradient(45deg, #10b981 30%, #059669 90%);
          color: white;
          border: none;
          padding: 1rem 1.5rem;
          border-radius: 12px;
          font-weight: 600;
          cursor: pointer;
          transition: all 0.3s ease;
          height: fit-content;
          box-shadow: 0 4px 16px rgba(16, 185, 129, 0.3);
        }

        .save-grade-btn:hover {
          transform: translateY(-2px);
          box-shadow: 0 8px 25px rgba(16, 185, 129, 0.4);
        }

        .current-grade {
          display: inline-flex;
          align-items: center;
          padding: 0.5rem 1rem;
          border-radius: 20px;
          font-weight: 600;
          font-size: 0.9rem;
          margin-left: 1rem;
        }

        .snackbar {
          position: fixed;
          bottom: 2rem;
          left: 50%;
          transform: translateX(-50%);
          padding: 1rem 2rem;
          border-radius: 12px;
          color: white;
          font-weight: 500;
          box-shadow: 0 8px 32px rgba(0,0,0,0.3);
          backdrop-filter: blur(10px);
          z-index: 1000;
          animation: slideInFromBottom 0.3s ease-out;
          display: flex;
          align-items: center;
          gap: 0.75rem;
          max-width: 400px;
        }

        .snackbar.success {
          background: rgba(16, 185, 129, 0.9);
        }

        .snackbar.error {
          background: rgba(239, 68, 68, 0.9);
        }

        .snackbar.warning {
          background: rgba(245, 158, 11, 0.9);
        }

        .snackbar.info {
          background: rgba(59, 130, 246, 0.9);
        }

        .snackbar-close {
          background: none;
          border: none;
          color: white;
          cursor: pointer;
          padding: 0.25rem;
          border-radius: 4px;
          opacity: 0.8;
        }

        .snackbar-close:hover {
          opacity: 1;
          background: rgba(255, 255, 255, 0.1);
        }

        /* Mobile responsiveness */
        @media (max-width: 768px) {
          .grade-submissions-container {
            padding: 1rem 0.5rem;
          }
          
          .form-container {
            padding: 2rem 1.5rem;
          }

          .grading-section {
            grid-template-columns: 1fr;
            gap: 1rem;
          }

          .submission-header {
            flex-direction: column;
            align-items: stretch;
          }

          .student-info {
            justify-content: center;
          }

          .snackbar {
            left: 1rem;
            right: 1rem;
            transform: none;
            max-width: none;
          }
        }
      `}</style>

      <div className="pulse-element"></div>
      
      <div className="grading-wrapper">
        {/* Header Section */}
        <div className="header-section">
          <div className="header-chip">
            <svg width="16" height="16" viewBox="0 0 24 24" fill="currentColor">
              <path d="M12,3L1,9L12,15L21,10.09V17H23V9M5,13.18V17.18L12,21L19,17.18V13.18L12,17L5,13.18Z"/>
            </svg>
            Teacher Dashboard
          </div>
          
          <h1 className="main-title">
            <span className="gradient-text">Grade</span> Submissions
          </h1>
          
          <p className="subtitle">
            Review and evaluate student assignments
          </p>
        </div>

        {/* Form Container */}
        <div className="form-container">
          <div className="form-title">
            <div className="form-icon">
              <svg width="24" height="24" viewBox="0 0 24 24" fill="currentColor">
                <path d="M12,3L1,9L12,15L21,10.09V17H23V9M5,13.18V17.18L12,21L19,17.18V13.18L12,17L5,13.18Z"/>
              </svg>
            </div>
            <div className="form-title-text">Assignment Grading</div>
          </div>
          
          <div className="form-group">
            <label className="form-label">Select Assignment to Grade</label>
            <select
              className="form-select"
              value={selectedAssignment}
              onChange={(e) => setSelectedAssignment(e.target.value)}
            >
              <option value="">-- Choose an Assignment --</option>
              {assignments.map(assignment => (
                <option key={assignment._id} value={assignment._id}>
                  {assignment.title}
                </option>
              ))}
            </select>
          </div>

          {loading ? (
            <div className="loading-container">
              <div className="loading-spinner"></div>
              <div className="loading-text">Loading submissions...</div>
            </div>
          ) : !selectedAssignment ? (
            <div className="empty-state">
              <div className="empty-icon">
                <svg width="48" height="48" viewBox="0 0 24 24" fill="currentColor">
                  <path d="M14,2H6A2,2 0 0,0 4,4V20A2,2 0 0,0 6,22H18A2,2 0 0,0 20,20V8L14,2M18,20H6V4H13V9H18V20Z"/>
                </svg>
              </div>
              <div className="empty-title">Select an Assignment</div>
              <div className="empty-message">
                Choose an assignment from the dropdown above to view and grade student submissions.
              </div>
            </div>
          ) : submissions.length === 0 ? (
            <div className="empty-state">
              <div className="empty-icon">
                <svg width="48" height="48" viewBox="0 0 24 24" fill="currentColor">
                  <path d="M19,3H5A2,2 0 0,0 3,5V19A2,2 0 0,0 5,21H19A2,2 0 0,0 21,19V5A2,2 0 0,0 19,3M19,19H5V5H19V19Z"/>
                </svg>
              </div>
              <div className="empty-title">No Submissions Yet</div>
              <div className="empty-message">
                Students haven't submitted any work for this assignment yet. Check back later.
              </div>
            </div>
          ) : (
            <div className="submissions-table">
              <div className="submissions-header">
                <div className="table-icon">
                  <svg width="20" height="20" viewBox="0 0 24 24" fill="currentColor">
                    <path d="M14,2H6A2,2 0 0,0 4,4V20A2,2 0 0,0 6,22H18A2,2 0 0,0 20,20V8L14,2M18,20H6V4H13V9H18V20Z"/>
                  </svg>
                </div>
                Student Submissions ({submissions.length})
              </div>

              {submissions.map((submission, index) => {
                const currentGrade = grading[submission._id]?.letterGrade || submission.letterGrade;
                const gradeStyle = getGradeColor(currentGrade);
                
                return (
                  <div 
                    key={submission._id} 
                    className="submission-card"
                    style={{ animationDelay: `${index * 0.1}s` }}
                  >
                    <div className="submission-header">
                      <div className="student-info">
                        <div className="student-avatar">
                          {submission.studentId.username.charAt(0).toUpperCase()}
                        </div>
                        <div>
                          <div className="student-name">{submission.studentId.username}</div>
                          {currentGrade && (
                            <div 
                              className="current-grade"
                              style={{
                                background: gradeStyle.bg,
                                color: gradeStyle.color,
                                border: `1px solid ${gradeStyle.border}`
                              }}
                            >
                              Current Grade: {currentGrade}
                            </div>
                          )}
                        </div>
                      </div>
                      
                      <button 
                        className="view-file-btn"
                        onClick={() => window.open(submission.fileUrl, '_blank')}
                      >
                        <svg width="20" height="20" viewBox="0 0 24 24" fill="currentColor">
                          <path d="M12,9A3,3 0 0,0 9,12A3,3 0 0,0 12,15A3,3 0 0,0 15,12A3,3 0 0,0 12,9M12,17A5,5 0 0,1 7,12A5,5 0 0,1 12,7A5,5 0 0,1 17,12A5,5 0 0,1 12,17M12,4.5C7,4.5 2.73,7.61 1,12C2.73,16.39 7,19.5 12,19.5C17,19.5 21.27,16.39 23,12C21.27,7.61 17,4.5 12,4.5Z"/>
                        </svg>
                        View Submission
                      </button>
                    </div>

                    <div className="grading-section">
                      <div className="grade-field">
                        <div className="field-label">Letter Grade</div>
                        <select
                          className="grade-select"
                          value={grading[submission._id]?.letterGrade || submission.letterGrade || ''}
                          onChange={(e) => handleGradeChange(submission._id, 'letterGrade', e.target.value)}
                        >
                          <option value="">-- Select Grade --</option>
                          {allowedGrades.map(grade => (
                            <option key={grade} value={grade}>{grade}</option>
                          ))}
                        </select>
                      </div>

                      <div className="grade-field">
                        <div className="field-label">Feedback (Optional)</div>
                        <textarea
                          className="feedback-input"
                          placeholder="Provide constructive feedback to help the student improve..."
                          value={grading[submission._id]?.feedback || submission.feedback || ''}
                          onChange={(e) => handleGradeChange(submission._id, 'feedback', e.target.value)}
                        />
                      </div>

                      <div className="grade-field">
                        <div className="field-label">Action</div>
                        <button 
                          className="save-grade-btn"
                          onClick={() => handleSubmitGrade(submission._id)}
                        >
                          <svg width="16" height="16" viewBox="0 0 24 24" fill="currentColor">
                            <path d="M21,7L9,19L3.5,13.5L4.91,12.09L9,16.17L19.59,5.59L21,7Z"/>
                          </svg>
                          Save Grade
                        </button>
                      </div>
                    </div>
                  </div>
                                  );
              })}
            </div>
          )}
        </div>
      </div>

      {/* Snackbar */}
      {snackbar.open && (
        <div className={`snackbar ${snackbar.severity}`}>
          <svg width="20" height="20" viewBox="0 0 24 24" fill="currentColor">
            {snackbar.severity === 'success' && (
              <path d="M21,7L9,19L3.5,13.5L4.91,12.09L9,16.17L19.59,5.59L21,7Z"/>
            )}
            {snackbar.severity === 'error' && (
              <path d="M19,6.41L17.59,5L12,10.59L6.41,5L5,6.41L10.59,12L5,17.59L6.41,19L12,13.41L17.59,19L19,17.59L13.41,12L19,6.41Z"/>
            )}
            {snackbar.severity === 'warning' && (
              <path d="M13,14H11V10H13M13,18H11V16H13M1,21H23L12,2L1,21Z"/>
            )}
            {snackbar.severity === 'info' && (
              <path d="M13,9H11V7H13M13,17H11V11H13M12,2A10,10 0 0,0 2,12A10,10 0 0,0 12,22A10,10 0 0,0 22,12A10,10 0 0,0 12,2Z"/>
            )}
          </svg>
          {snackbar.message}
          <button className="snackbar-close" onClick={closeSnackbar}>
            <svg width="16" height="16" viewBox="0 0 24 24" fill="currentColor">
              <path d="M19,6.41L17.59,5L12,10.59L6.41,5L5,6.41L10.59,12L5,17.59L6.41,19L12,13.41L17.59,19L19,17.59L13.41,12L19,6.41Z"/>
            </svg>
          </button>
        </div>
      )}
    </div>
  );
};

export default GradeSubmissions;